const ACTION_PREFIX = "ForgetPasswordSendEmail/";
export const ACTION_TYPE_SET_PAGE = ACTION_PREFIX + "setPage";

export const setPage = (page) => ({
    type: ACTION_TYPE_SET_PAGE,
    page: page
});
